import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { Category } from "../../../model/Category";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetAllCategoriesUseCase {
  invoke: () => Promise<ResponseState<Array<Category>>>;
}

export class GetAllCategoriesUseCaseImpl implements GetAllCategoriesUseCase {
  private categoryRepository: CategoryRepository;

  constructor(categoryRepository: CategoryRepository) {
    this.categoryRepository = categoryRepository;
  }

  async invoke(): Promise<ResponseState<Array<Category>>> {
    try {
      let response = await this.categoryRepository.getCategories();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
